<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-alert v-model="error" type="error" dismissible dense outlined>
        {{ errorMsg ? errorMsg : $t('login_error') }}
      </v-alert>
    </v-col>
    <v-col cols="12" v-if="enFooter">
      <p class="mb-2 font-weight-bold">
        {{ $t('acceso_usuario') }}
      </p>
    </v-col>
    <v-col cols="12">
      <v-text-field :label="$t('label_login')" v-model="loginUsuario" :single-line="enFooter"
                    :height="enFooter ? '45px': undefined" :solo="enFooter" :hide-details="!enFooter"
                    :prepend-inner-icon="enFooter ? undefined : 'mdi-account'"/>
      <v-text-field :label="$t('label_password')" v-model="loginContrasenya" :single-line="enFooter"
                    :height="enFooter ? '45px' : undefined" :solo="enFooter" hide-details
                    :prepend-inner-icon="enFooter ? undefined : 'mdi-lock'"
                    type="password" v-on:keyup.enter="login()"/>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters class="mt-6">
        <v-col cols="8">
          <a @click="goTo('/registro')" class="mb-1 hand d-block" :class="clasesEnlaces"
             v-html="$t('registro')"/>
          <a @click="goTo('/recuperar-contrasenya')" class="mb-1 hand d-block" :class="clasesEnlaces"
             v-html="$t('contrasenya')"/>
          <a @click="goTo('/reenviar-codigo-activacion')" class="mb-1 hand d-block" :class="clasesEnlaces"
             v-html="$t('activacion')"/>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn :color="colorBtn" :outlined="enFooter" :depressed="!enFooter"
                 :class="{'white--text': enFooter}" :disabled="!loginValido()" :loading="iniciando"
                 @click="login()">
            <span class="mr-2">{{ $t('entrar') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import LoginServicio from "@/comunes/servicios/LoginServicio";

export default {
  name: "LoginComponent",
  data: () => ({
    loginUsuario: null,
    loginContrasenya: null,
    iniciando: false,
    error: false,
    errorMsg: null
  }),
  props: {
    enFooter: {type: Boolean, default: false}
  },
  computed: {
    clasesEnlaces() {
      return {
        'caption': this.enFooter,
        'body-2': !this.enFooter,
        'white--text': this.enFooter,
        'primary--text': !this.enFooter
      }
    },
    colorBtn() {
      if (!this.enFooter) return "primary";
      return this.error ? 'red' : 'white';
    }
  },
  methods: {
    goTo(path) {
      VueRouteHelper.goTo(path, this.$router);
    },
    loginValido() {
      if (this.loginUsuario == null || this.loginUsuario.length < 3) return false;
      if (this.loginContrasenya == null || this.loginContrasenya.length < 3) return false;

      return true;
    },
    login() {
      if (!this.loginValido()) return;
      this.iniciando = true;
      this.error = false;
      LoginServicio.login(this.loginUsuario, this.loginContrasenya)
          .then(() => {
            this.loginUsuario = "";
            this.$emit("loginCorrecto");
          })
          .catch((error) => {
            this.error = true;
            if (error && error.mensaje) this.errorMsg = error.mensaje;
          })
          .finally(() => {
            this.loginContrasenya = "";
            this.iniciando = false;
          });
    },
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "acceso_usuario": "Acceso usuarios",
    "registro": "¿Aún no tienes cuenta? <span class='font-weight-bold'>Regístrate</span>",
    "contrasenya": "¿Has olvidado la contraseña?",
    "activacion": "¿No has podido activar tu cuenta?",
    "login_error": "Usuario o contraseña incorrectos",
    "entrar": "Entrar",
    "iniciar_sesion": "Iniciar sesión",
    "label_login": "usuario o email",
    "label_password": "contraseña"
  }
}
</i18n>
<!--@formatter:on-->